import { useMutation } from '@apollo/client';
import { CREATE_PRODUCT_REVIEW } from 'graphql/mutations';

export default function useReview(rating, sku) {
  const [addReview, { data, loading }] = useMutation(CREATE_PRODUCT_REVIEW);

  const onSubmit = async data => {
    let value;

    switch (rating) {
      case 1:
        value = 'MTY=';
        break;
      case 2:
        value = 'MTc=';
        break;
      case 3:
        value = 'MTg=';
        break;
      case 4:
        value = 'MTk=';
        break;
      case 5:
        value = 'MjA=';
        break;
      default:
    }

    await addReview({
      variables: {
        sku,
        nickname: data?.reviewer,
        text: data?.comment,
        value
      }
    });
  };

  return { onSubmit, data, loading };
}
